// The room a preview's sample is drawn in, in pixels
export const PREVIEW_CHART_SIZE = { width: 260, height: 124 };

// The sample's width, less the stage's and its gadget's padding and borders
export const PREVIEW_WIDTH = PREVIEW_CHART_SIZE.width + 48;

// The previews' entrances (counting up, drawing in) are skipped for those
// who'd rather not see motion
export const isReducedMotion = () =>
  typeof window !== 'undefined' &&
  typeof window.matchMedia === 'function' &&
  window.matchMedia('(prefers-reduced-motion: reduce)').matches;
